import React, { ReactElement } from "react";
import { GetStaticProps } from "next";
import SeveralBrandsWrapper from "@components/layouts/severalBrandsWrapper";
import CcpaPrivacyNotice from "@components/shared/legal/ccpaPrivacyNotice";
import { DomainInfo } from "@components/severalbrands/utils/services";
import initialCall from "@components/severalbrands/utils/initialCall";
import MetaTags from "@components/severalbrands/metaTags";
import {
    getKeyWordsForMetaTags,
    getMetaTitleDescriptionForPage,
} from "@components/severalbrands/utils";
import styles from "@components/severalbrands/legal/style.module.scss";

export default function SeveralBrandsHome({
    domain,
}: {
    domain: DomainInfo;
}): ReactElement {
    const metaTags = getMetaTitleDescriptionForPage(
        domain,
        "CcpaPrivacyNotice",
    );
    return (
        <SeveralBrandsWrapper domainInfo={domain}>
            <MetaTags
                title={
                    metaTags?.title ??
                    "Privacy Notice for California Residents | SeveralBrands.com"
                }
                description={
                    metaTags?.description ??
                    "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks."
                }
                keyWords={getKeyWordsForMetaTags(domain)}
            />
            <CcpaPrivacyNotice mainWrapperClassName={styles["mainContainer"]} />
        </SeveralBrandsWrapper>
    );
}

//@ts-ignore
export const getStaticProps: GetStaticProps = async () => {
    return await initialCall("CcpaPrivacyNotice");
};
